import React from "react";
import "./ToggleGroup.css";

/**
 * Segmented control — 2+ mutually exclusive options (e.g. grid / list view).
 * Surface-aware.
 *
 * Props:
 *   options:  [{ value, label?, icon?, ariaLabel? }]
 *   value:    selected value
 *   onChange: (value) => void
 *   size:     "sm" | "md"   (default "md")
 */
const ToggleGroup = ({ options = [], value, onChange, size = "md", className = "" }) => (
  <div className={`gx-toggle gx-toggle--${size} ${className}`} role="group">
    {options.map((opt) => {
      const active = opt.value === value;
      return (
        <button
          key={opt.value}
          type="button"
          aria-pressed={active}
          aria-label={opt.ariaLabel || opt.label}
          className={`gx-toggle-opt ${active ? "is-active" : ""}`}
          onClick={() => onChange && onChange(opt.value)}
        >
          {opt.icon && <span className="gx-toggle-icon">{opt.icon}</span>}
          {opt.label && <span>{opt.label}</span>}
        </button>
      );
    })}
  </div>
);

export default ToggleGroup;
